import NextLink from "next/link";

// mui
import Link, { LinkProps } from "@mui/material/Link";

// Linkを共通化するにあたって、二パターン用意した。
// 1. 普通のLink(disableは可能)
// 2. permissionによって表示、非表示が変わるLink(disableという概念がない。表示されなくなるので)
//   (2はPermissionComponentというファイル内にpermisseion系をまとめておいている)
//   1と2で受け取る引数が微妙に変わるので、BaseLinkを定義して、1と2でそれを呼び出すような実装にした。

// - Linkタグの使われ方として二パターンある。
//   - onClickでサイドのinfoBarを出したりする
//   - hrefで普通に画面遷移させる
//   onclickはあったりなかったりするので、それの有無でcomponentを分岐させてる。
// - onClickの際にもloadingが走るので、UXのためにcomponentを分離してloadingを不要に走らせないようにした。
export const BaseLink = (props: LinkProps): JSX.Element => {
  const { href, onClick, target, rel, children } = props;

  const WithoutOnClick = (): JSX.Element => {
    if (!href) return <></>;

    return (
      <NextLink href={href} passHref>
        {/* targetを使う場合はrelを指定させるべきなのでセットで判断する */}
        {target && rel ? (
          <Link underline="none" target={target} rel={rel}>
            {children}
          </Link>
        ) : (
          <Link underline="none">{children}</Link>
        )}
      </NextLink>
    );
  };

  const WithOnClick = (): JSX.Element => {
    if (!onClick) return <></>;

    return (
      <Link underline="none" onClick={onClick}>
        {children}
      </Link>
    );
  };

  return onClick ? <WithOnClick /> : <WithoutOnClick />;
};

type NormalLinkType = {
  disabled?: boolean;
};

// disabledのリンク
const NitoelLink = (props: LinkProps & NormalLinkType): JSX.Element => {
  const { disabled, children, ...others } = props;

  if (disabled) {
    return <>{children}</>;
  }

  return <BaseLink {...others}>{children}</BaseLink>;
};

export default NitoelLink;
